import { Legend } from "./basicModels";

export const legendModel = Legend;
